/**
 * Build a transformed Supabase Storage image URL for SEO/performance.
 * Uses Supabase's render/image/public endpoint which auto-serves WebP and resizes
 * on the fly, dramatically reducing payload for thumbnails (avatars, previews).
 *
 * Falls back to the original URL if it isn't a Supabase public storage URL,
 * so non-Supabase or already-transformed URLs are passed through unchanged.
 */
export function transformStorageImage(
  url: string | null | undefined,
  opts: { width?: number; height?: number; quality?: number; resize?: "cover" | "contain" | "fill" } = {}
): string | undefined {
  if (!url) return undefined;
  try {
    // Only transform Supabase public object URLs
    if (!url.includes("/storage/v1/object/public/")) return url;

    const { width, height, quality = 75, resize = "cover" } = opts;
    const transformed = url.replace(
      "/storage/v1/object/public/",
      "/storage/v1/render/image/public/"
    );
    const u = new URL(transformed);
    if (width) u.searchParams.set("width", String(width));
    if (height) u.searchParams.set("height", String(height));
    u.searchParams.set("quality", String(quality));
    u.searchParams.set("resize", resize);
    return u.toString();
  } catch {
    return url;
  }
}
